import { Component, h, Host, Prop } from '@stencil/core';
import { getInputVariantClass, InputVariant } from '../uui-input-utils';

@Component({
  tag: 'uui-input-title',
  styleUrl: 'uui-input-title.css',
  shadow: true
})
export class UUIInputTitle {
  @Prop({ mutable: true, reflect: true }) error: boolean = false;
  @Prop({ mutable: true, reflect: true }) warning: boolean = false;
  @Prop({ mutable: true, reflect: true }) disabled: boolean = false;
  @Prop({ mutable: true, reflect: true }) hasinfo: boolean = false;
  @Prop({ mutable: true, reflect: true }) infotext: string = '';
  @Prop() for: string = '';
  @Prop({ mutable: true, reflect: true }) infowidth: string = '120px';
  @Prop() infoposition: 'top' | 'bottom' | 'left' | 'right' = 'top';

  get variant(): InputVariant {
    return getInputVariantClass({
      isError: this.error,
      isWarning: this.warning
    });
  }

  render() {
    return (
      <Host>
        <label
          class={`label ${this.variant} ${this.disabled ? 'disabled' : ''}`}
          htmlFor={this.for}
        >
          <slot />
        </label>
        <div class={this.hasinfo ? 'icon' : 'icon hide-icon'}>
          <uui-tooltip
            text={this.infotext}
            width={this.infowidth}
            position={this.infoposition}
          >
            <svg
              class={`uui-input-title-icon ${this.variant}`}
              id="light-info-circle"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z" />
            </svg>
          </uui-tooltip>
        </div>
      </Host>
    );
  }
}
